import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css'; // Add css for snow theme
import React, { useState } from 'react';
import Button from '@/components/Button';

const AddTextContent = ({
  saveNote,
}: {
  saveNote: (content: string) => void;
}) => {
  const [noteContent, setNoteContent] = useState<string>('');
  const theme = 'snow';
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['link', 'image', 'video', 'formula'],
      ['clean'],
    ],
  };

  const placeholder = '...';

  const formats = ['bold', 'italic', 'underline', 'strike'];

  const { quill, quillRef } = useQuill({
    theme,
    modules,
    formats,
    placeholder,
  });

  React.useEffect(() => {
    if (quill) {
      quill.on('text-change', () => {
        const htmlString = quill.root.innerHTML;
        setNoteContent(htmlString);
      });
    }
  }, [quill]);

  const saveTextNote = () => {
    saveNote(noteContent);
  };

  return (
    <>
      <div
        style={{ width: '100%', height: '100%', border: '1px solid lightgray' }} >
        <div ref={quillRef} />
      </div>
      <Button
        className="obro-secondary-btn full-w margin-top-10"
        onClick={() => saveTextNote()}
      >
        Kaydet
      </Button>
    </>
  );
};

export default AddTextContent;
